import React from 'react';

import styles from './notebox.module.scss';

const Notebox = ({ note }) => {
  return <div className={styles.notebox}>{note}</div>;
};

export default Notebox;
